
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const GuestRoute = ({ children }) => {
    const { auth } = useContext(AuthContext);

    if (auth.loading) {
        return null;
    }

    return !auth.isAuthenticated ? children : <Navigate to="/" />;
};

export default GuestRoute;
